import React from 'react'
import { StaticGrid } from 'components/common'
import WorksLazyGrid from './WorksLazyGrid'

const WorksPanel = ({
    works,
    contactId,
    lazyLoadWorks,
    worksCount
}) => {
    const hasContact = works !== null || lazyLoadWorks
    const hasWorks = (works && works.length > 0) || lazyLoadWorks

    const workTypeTemplate = (rowData) => {
        return (
            <span className="p-tag custom-badge-base custom-badge-aqua-3">
                {rowData.type}
            </span>
        )
    }

    const episodeTitleTemplate = (rowData) => rowData.episodeTitle || '-'
    const contributionTemplate = (rowData) => rowData.contribution || '-'
    const isbnTemplate = (rowData) => rowData.isbn || '-'
    const issnTemplate = (rowData) => rowData.issn || '-'

    const columnDefinitions = [
        { columnType: 'worktype', title: 'Type', mapsToField: 'type', template: workTypeTemplate, filter: true, sortable: true },
        { columnType: 'text', title: 'Title', mapsToField: 'title', filter: true, sortable: true },
        { columnType: 'text', title: 'Episode Title', mapsToField: 'episodeTitle', template: episodeTitleTemplate, filter: true, sortable: true },
        { columnType: 'workcontributiontype', title: 'Contribution', mapsToField: 'contribution', template: contributionTemplate, filter: true, sortable: true },
        { columnType: 'text', title: 'ISBN', mapsToField: 'isbn', template: isbnTemplate, filter: false, sortable: false },
        { columnType: 'text', title: 'ISSN', mapsToField: 'issn', template: issnTemplate, filter: false, sortable: false }
    ]

    // Render LazyGrid for >50 works, StaticGrid for <=50 works
    const renderWorksGrid = () => {
        if (lazyLoadWorks) {
            return (
                <WorksLazyGrid
                    contactId={contactId}
                    worksCount={worksCount}
                />
            )
        }

        return (
            <StaticGrid
                id="works"
                dataKey="id"
                data={works}
                columnDefinitions={columnDefinitions}
                showPaginator={false}
                scrollHeight="auto"
                emptyMessage="No works found"
            />
        )
    }

    return (
        <div className="works-panel contact-search-panel">
            {/* Only show title for StaticGrid - LazyGrid has its own title with filtered count */}
            {!lazyLoadWorks && (
                <h5 className="contact-search-panel-title mb-2">
                    Works{works?.length > 0 ? ` (${works.length})` : ''}
                </h5>
            )}
            {hasContact ? (
                hasWorks ? (
                    renderWorksGrid()
                ) : (
                    <div className="contact-search-empty-message">
                        No works found for this contact
                    </div>
                )
            ) : (
                <div className="contact-search-empty-message">
                    Select a contact to view works
                </div>
            )}
        </div>
    )
}

export default WorksPanel
